module.exports = __webpack_public_path__ + "img/1.63942e6d.webp";